/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NonceAttestationData
 */
export interface NonceAttestationData {
    /**
     * 
     * @type {string}
     * @memberof NonceAttestationData
     */
    challenge?: string;
}

/**
 * Check if a given object implements the NonceAttestationData interface.
 */
export function instanceOfNonceAttestationData(value: object): value is NonceAttestationData {
    return true;
}

export function NonceAttestationDataFromJSON(json: any): NonceAttestationData {
    return NonceAttestationDataFromJSONTyped(json, false);
}

export function NonceAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
    };
}

export function NonceAttestationDataToJSON(json: any): NonceAttestationData {
    return NonceAttestationDataToJSONTyped(json, false);
}

export function NonceAttestationDataToJSONTyped(value?: NonceAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': value['challenge'],
    };
}

